import axios from 'axios';

// Relative baseURL on purpose: requests go through the dev proxy (vite.config
// proxies /api3.2 -> Node and injects x-forwarded-host, which the backend needs
// to resolve the current user from the ptshared cookie) and through same-origin
// IIS in production. Hitting localhost:10000 directly would bypass that proxy
// and break local user resolution. withCredentials sends the ptshared cookie.
const onboardingApi = axios.create({
  baseURL: '/api3.2/onboarding',
  withCredentials: true,
});

export default onboardingApi;
